import React from 'react'
import TableComponent, { TableOp } from '../../../components/table/TableOps'
import ACCESS from '../../../ACCESS';
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import Toast from 'react-hot-toast';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import PDFViewer from '../../../components/pdfViewer';
import EmbarqueGuiasCartaPorte from './EmbarqueGuiasCartaPorte';
import EmbarqueCartaPorteDatos from './EmbarqueCartaPorteDatos';

const MODALS = {
  'MODAL_PDF': 1,
  'MODAL_GUIAS': 2,
  'EDIT_CARTA_PORTE': 3,
}

class EmbarqueCartasPorte extends TableComponent {
  id_embarque = this.props.match.params.id

  componentDidMount() {
    if (this.id_embarque && !isNaN(this.id_embarque)) {
      let acciones = [
        { id: 'timbrar', icon: 'description', tooltip: 'Timbrar Carta Porte', access: [ACCESS.EMBARQUE.GENERAR_CARTA_PORTE_DEL_EMBARQUE] },
        { id: 'carta_porte', icon: 'picture_as_pdf', tooltip: 'Ver Archivos', access: [ACCESS.EMBARQUE.GENERAR_CARTA_PORTE_DEL_EMBARQUE] },
        { id: 'view', icon: 'visibility', tooltip: 'Ver Guias', access: [ACCESS.EMBARQUE.GENERAR_CARTA_PORTE_DEL_EMBARQUE] },
      ];

      this.tableConfig(
        { dataUrl: `embarque/${this.id_embarque}/facturas`, deleteUrl: '', deleteField: '', modUrl: '' },
        TableOp.Table(`Cartas Porte Embarque #${this.id_embarque}`, [
          { label: 'Guia', id: 'guia' },
          { label: 'Cliente', id: 'cliente' },
          { label: 'Factura', id: 'factura' },
          { label: 'Tipo', id: 'source' },
          { label: 'Estatus', id: 'estado' },
          { label: 'Usuario', id: 'usuario' },
        ], acciones))
      this.table();
    }
  }

  action = (id, row) => {
    if (this.state.loading) {
      return Toast.error('Esperando Carta porte...');
    }
    if (id === 'timbrar') {
      this.timbrarCartaPorte(row)
    } else if (id === 'carta_porte') {
      this.downloadPDFCartaPorte(row.id_factura)
    } else if (id === 'view') {
      this.setState({ modal: MODALS.MODAL_GUIAS, row })
    }
  }

  downloadPDFCartaPorte = async (id) => {
    if (!id) {
      return Toast.error('Todavia no se ha timbrado')
    }
    this.setState({ loading: true });
    const Resp = await Http.get(`carta-porte/factura-pdf/${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/pdf' });
      this.setState({
        loading: false,
        pdfURL: URL.createObjectURL(blob),
        modal: MODALS.MODAL_PDF,
        downloadZip: true,
        dCarta: false,
        id_factura: id,
      });
    }
  }

  timbrarCartaPorte = async (row) => {
    try {
      this.setState({ loading: true });
      const Resp = await Http.post(`embarque/timbrar`, { id_guia: row.id_guia, id_cliente: row.id_cliente, id_embarque: this.id_embarque });
      if (!Resp.error) {
        return Toast.success('Se ha timbrado correctamente');
      } else {
        return Toast.error(Resp.errMsg);
      }
    } catch (error) {
      return Toast.error('Error Inesperado');
    } finally {
      this.setState({ loading: false });
    }
  }

  timbrarCartaPorteEmbarque = async (row) => {
    try {
      this.setState({ loading: true });
      const Resp = await Http.post(`embarque/timbrar-multiple`, { id_embarque: this.id_embarque });
      if (!Resp.error) {
        return Toast.success('Se ha timbrado correctamente');
      } else {
        return Toast.error(Resp.errMsg);
      }
    } catch (error) {
      return Toast.error('Error Inesperado');
    } finally {
      this.setState({ loading: false });
    }
  }

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = pdfURL;
    a.download = `embarque.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  }

  viewPdfClose = () => {
    this.setState({ modal: null });
  };

  editCartaPorteClose = () => {
    this.setState({ modal: null });
  };

  handledownloadXml = async () => {
    const { id_factura } = this.state;
    const Resp = await Http.get(`carta-porte/factura-xml/${id_factura}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/xml' });
      const zipURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = zipURL;
      a.download = `cartas_porte_${id_factura}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(zipURL);
    }
  }

  render() {
    const { pdfURL = '', modal, row } = this.state;
    return (
      <div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} >
          <Button
            variant="contained"
            color='primary'
            onClick={this.timbrarCartaPorteEmbarque}
            style={{ marginRight: 10 }}
          >
            Timbrar Todo
          </Button>
          <Button
            variant="contained"
            color='secondary'
            onClick={() => { this.setState({ modal: MODALS.EDIT_CARTA_PORTE }) }}
          >
            Editar Datos
          </Button>
        </div>
        <this.TableRender pagination={false} />

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={modal === MODALS.MODAL_PDF}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <PDFViewer
                  alert={err => (
                    <div
                      style={{
                        color: '#fa5b35',
                      }}>
                      <h6>No hay guías en el embarque</h6>
                    </div>
                  )}
                  scale={1}
                  style={{ height: 400 }}
                  document={{
                    url: pdfURL,
                  }}
                  pdfUrl={pdfURL}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={this.handledownloadPdf}
            >
              Descargar Pdf
            </Button>
            <Button
              variant="contained"
              onClick={this.handledownloadXml}
            >
              Descargar XML
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={modal === MODALS.MODAL_GUIAS}
          maxWidth={"md"}
        >
          <DialogTitle style={{ paddingBottom: 0 }} >Guias - {row?.cliente}</DialogTitle>
          <DialogContent>
            <EmbarqueGuiasCartaPorte
              id_embarque={this.id_embarque}
              id_cliente={row?.id_cliente}
              id_guia={row?.id_guia}
            />
          </DialogContent>
          <DialogActions>
            <Button variant='contained' color='primary' onClick={this.viewPdfClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.editCartaPorteClose}
          open={modal === MODALS.EDIT_CARTA_PORTE}
          maxWidth={"md"}
        >
          <DialogContent>
            <EmbarqueCartaPorteDatos idEmbarque={this.id_embarque} onClose={this.editCartaPorteClose} />
          </DialogContent>
        </Dialog>

      </div>
    )
  }
}

export default withRouter(EmbarqueCartasPorte)
